/** The second level of Settings' tabs, as data: the screens that sit under "You" and under
 * "Organisation". One list per group so the screens that draw it cannot disagree about its order. */

import type { PageLink } from "../components/PageLinks";

export const YOU_LINKS: readonly PageLink[] = [
  { to: "/profile", label: "Profile" },
  { to: "/settings", label: "Sign-in & notifications" },
  { to: "/privacy-requests", label: "Your data" },
];

export const ORGANISATION_LINKS: readonly PageLink[] = [
  { to: "/organisation", label: "Companies & sites" },
  { to: "/financials", label: "Financials & scope" },
];
